import { useDispatch, useSelector } from "react-redux";
import { addCardItem, setCard } from "../features/card/cardSlice";
import {
  setBasketItem,
  removeBasketItem,
} from "../features/card/cardActions";

const useCard = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state?.auth?.isAuthenticated);
  const items = useSelector((state) => state?.card?.items);

  function addToCard(selectedVariant, count, product) {
    if (isAuthenticated) {
      // Server basket is the source of truth: send the absolute new quantity.
      const existing = items?.find(
        (el) =>
          el?.variant?.id?.toString() === selectedVariant?.id?.toString()
      );
      // Returned so callers can await the server confirmation (loading UI,
      // success/error feedback). The guest branch below is synchronous.
      return dispatch(
        setBasketItem({
          variant_id: selectedVariant?.id,
          quantity: (Number(existing?.quantity) || 0) + count,
        })
      );
    }
    return dispatch(
      addCardItem({
        menu_item: product?.id,
        details: product,
        quantity: count,
        variant: selectedVariant,
        key: selectedVariant?.id,
        id: product?.id,
      })
    );
  }

  function editCard(newItems) {
    if (isAuthenticated) {
      // Callers pass the full edited list (one line changed or removed) —
      // diff it against current state and sync that one line to the server.
      const removed = items?.find(
        (el) => !newItems?.some((n) => n?.key === el?.key)
      );
      if (removed) {
        dispatch(removeBasketItem(removed?.variant?.id));
        return;
      }
      const changed = newItems?.find((n) => {
        const old = items?.find((el) => el?.key === n?.key);
        return old && Number(old?.quantity) !== Number(n?.quantity);
      });
      if (changed) {
        dispatch(
          setBasketItem({
            variant_id: changed?.variant?.id,
            quantity: Number(changed?.quantity),
          })
        );
      }
      return;
    }
    dispatch(setCard(newItems));
  }

  return {
    addToCard,
    editCard
  };
};
export default useCard;
